const addressFormNewGuestSubmit = document.querySelector('#address_form_new_guest_submit');

if (addressFormNewGuestSubmit) {
  addressFormNewGuestSubmit.addEventListener('click', async (e) => {
    e.preventDefault();
    removeOhnutsInfo("ohnuts_single_address_info");
    removeOhnutsInfo("ohnuts_guest_address_list");
    addClassesToElements(
      '#address_form_new_guest_submit',
      ['loading', 'read-only']
    );
    let valid_address = await validateGuestAddressForm();
    if (!valid_address) {
      return removeClassesFromElements(
        '#address_form_new_guest_submit',
        ['loading', 'read-only']
      );
    }
    showOhnutsLoadingSpinner();
    saveGuestAddress(valid_address);
    renderGuestAddressList();
    hideOhnutsLoadingSpinner();
    removeClassesFromElements(
      '#addAddressForShipping',
      ['loading', 'read-only']
    );
    removeClassesFromElements(
      '#address_form_new_guest_submit',
      ['loading', 'read-only']
    );
    //return;
    //window.location.href = ADDRESS_LIST_URL;
  });
}

async function validateGuestAddressForm() {
  showOhnutsLoadingSpinner();

  const valid_address = {};
  const invalid_fields = [];
  const guestAddressList = getGuestAddressList();

  function getFieldValue(selector, key, required = true) {
    const value = document.querySelector(selector).value.trim();
    if (value || !required) {
      valid_address[key] = value;
    } else {
      invalid_fields.push(key);
    }
    return value;
  }

  function getCountryAndProvince() {
    const country_ele = document.querySelector("#AddressCountryNew");
    const province_ele = document.querySelector("#AddressProvinceNew");

    const selected_country_index = country_ele.selectedIndex;
    const country_list = country_ele.options;
    const country_name = country_list[selected_country_index]?.value.trim() || "";
    if (country_name !== "---" || country_name !== "") {
      valid_address["country"] = valid_address["country_name"] = country_name;
    } else {
      invalid_fields.push("country");
    }

    let country_provinces;
    try {
      country_provinces = JSON.parse(
        country_list[selected_country_index]?.getAttribute("data-provinces") || "[]"
      );
      
    } catch {
      console.error(`[getCountryAndProvince] Invalid provinces JSON: ${error.message}`);
      country_provinces = [];
    }

    const selected_province_index = province_ele.selectedIndex;
    const province_list = province_ele.options;
    const province_name = province_list[selected_province_index]?.value || "";

    if (country_provinces.length) {
      if (selected_province_index >= 0 && province_name !== "") {
        valid_address["province"] = province_name;
      } else {
        invalid_fields.push("province");
      }
    } else {
      valid_address["province"] = "";
    }
  }

  function isDuplicateAddress() {
    return guestAddressList.some((address) => {
      return (
        address.address1.toLowerCase() === valid_address["address1"].toLowerCase() &&
        address.city.toLowerCase() === valid_address["city"].toLowerCase() &&
        address.country.toLowerCase() === valid_address["country"].toLowerCase() &&
        address.province.toLowerCase() === valid_address["province"].toLowerCase() &&
        address.zip.toLowerCase() === valid_address["zip"].toLowerCase()
      );
    });
  }

  getFieldValue("#AddressFirstNameNew", "first_name");
  getFieldValue("#AddressLastNameNew", "last_name");
  getFieldValue("#AddressCompanyNew", "company", false);
  getFieldValue("#AddressAddress1New", "address1");
  getFieldValue("#AddressAddress2New", "address2", false);
  getFieldValue("#AddressCityNew", "city");
  getFieldValue("#AddressZipNew", "zip");
  getFieldValue("#AddressPhoneNew", "phone", false);

  valid_address["default"] = !!document.querySelector(
    "#address_default_address_new:checked"
  );

  getCountryAndProvince();

  if (invalid_fields.length) {
    hideOhnutsLoadingSpinner();
    showOhnutsCustomModal(
      "Fill up all the required fields",
      "Address Error",
      "Close"
    );
    return null;
  }

  if (isDuplicateAddress()) {
    hideOhnutsLoadingSpinner();
    showOhnutsCustomModal(
      "Address with same field info already exists!",
      "Address Error",
      "Close"
    );
    return null;
  }

  valid_address["id"] = `${new Date().getTime()}-guest`;
  valid_address["customer_id"] = "";
  valid_address["name"] = `${valid_address["first_name"]} ${valid_address["last_name"]}`.trim();

  hideOhnutsLoadingSpinner();
  return valid_address;
}

  const input = document.getElementById('AddressAddress1New');
  const suggestionsContainer = document.getElementById('addressSuggestions');
  const address1Field= document.getElementById('AddressAddress1New');
  const address2Field= document.getElementById('AddressAddress2New');
  const cityField = document.getElementById('AddressCityNew');
  const countryField = document.getElementById('AddressCountryNew');
  const pinField = document.getElementById('AddressZipNew');
  const stateField = document.getElementById('AddressProvinceNew');
  let debounceTimeout;
  address2Field.addEventListener('focus', () => {
    suggestionsContainer.innerHTML = '';
  });
  cityField.addEventListener('focus', () => {
    suggestionsContainer.innerHTML = '';
  });
  countryField.addEventListener('focus', () => {
    suggestionsContainer.innerHTML = '';
  });
  pinField.addEventListener('focus', () => {
    suggestionsContainer.innerHTML = '';
  });
  stateField.addEventListener('focus', () => {
    suggestionsContainer.innerHTML = '';
  });
  function disableBrowserAutocomplete() {
    input.setAttribute('autocomplete', 'nope'); 
  }
  
  function enableBrowserAutocomplete() {
    input.setAttribute('autocomplete', 'street-address'); 
  }
  if (input) {
    input.addEventListener('input', (e) => {
     
      if(e.inputType===undefined){
        return;
      }
      clearTimeout(debounceTimeout);
      disableBrowserAutocomplete();
      debounceTimeout = setTimeout(async () => {
        const value = input.value.trim();
        if (value.length > 0 && value.length < 30) {
          try {
            const suggestions = await callAddressSuggestion(value);
            
            displaySuggestions(suggestions);
          } catch (error) {
            enableBrowserAutocomplete();
            console.error('Error fetching suggestions:', error);
          }
        } else {
          enableBrowserAutocomplete() ;
          suggestionsContainer.innerHTML = ''; // Clear suggestions
        }
      }, 300);
    });
  }

  //======//
  //======//



  // const input = document.getElementById('AddressAddress1New');
  // const suggestionsContainer = document.getElementById('addressSuggestions');
  // const address1Field = document.getElementById('AddressAddress1New');
  // const address2Field = document.getElementById('AddressAddress2New');
  // const cityField     = document.getElementById('AddressCityNew');
  // const countryField  = document.getElementById('AddressCountryNew');
  // const pinField      = document.getElementById('AddressZipNew');
  // const stateField    = document.getElementById('AddressProvinceNew');
  // let debounceTimeout;
  // let isInputFocused = false;
  
  // if (input) {
  //   input.addEventListener('focus', () => {
  //     isInputFocused = true;
  //   });
  //   input.addEventListener('blur', () => {
  //     isInputFocused = false;
  //     setTimeout(() => {   // small delay to allow click on suggestion
  //       suggestionsContainer.innerHTML = '';
  //       suggestionsContainer.style.display = 'none';
  //       enableBrowserAutocomplete();
  //     }, 150);
  //   });
  //   input.addEventListener('input', () => {
  //     clearTimeout(debounceTimeout);
  //     debounceTimeout = setTimeout(async () => {
  //       const value = input.value.trim();
  //       if (!isInputFocused) return;
  //       if (value.length > 0 && value.length < 60) {
  //         try {
  //           disableBrowserAutocomplete();
  //           const suggestions = await callAddressSuggestion(value);
  //           displaySuggestions(suggestions);
  //           suggestionsContainer.style.display = 'block';
  //         } catch (error) {
  //           console.error('Error fetching suggestions:', error);
  //         }
  //       } else {
  //         enableBrowserAutocomplete();
  //         suggestionsContainer.innerHTML = '';
  //         suggestionsContainer.style.display = 'none';
  //       }
  //     }, 300);
  //   });
  //   input.addEventListener('keydown', (event) => {
  //     if (event.key === 'Tab') {
  //       suggestionsContainer.innerHTML = '';
  //       suggestionsContainer.style.display = 'none';
  //       enableBrowserAutocomplete();
  //     }
  //   });
  // }
  // function disableBrowserAutocomplete() {
  //   input.setAttribute('autocomplete', 'nope'); 
  // }
  
  // function enableBrowserAutocomplete() {
  //   input.setAttribute('autocomplete', 'street-address'); 
  // }
  async function callAddressSuggestion(addressLine) {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ addressLine }),
    };
    try {
      //const response = await fetch(`https://shopifymultishipapp-ec3e3bef6fd5.herokuapp.com/address_suggestions-gapi`, requestOptions);
      const response = await fetch(`${SHOPIFY_APP_BASE_URL}/address-suggestions-gapi`, requestOptions);
      const result = await response.json();
      if (result?.status?.toLowerCase() === "ok") {
        return result.data || {};
      } else {
        console.warn("Failed to fetch address suggestions:", result.message || "Unknown error");
        return {};
      }
    } catch (error) {
      console.error("Error fetching address suggestions:", error);
      return {};
    }
  }

  async function displaySuggestions(suggestionsObject) {
    suggestionsContainer.innerHTML = ''; 
    Object.entries(suggestionsObject).forEach(([placeId, text]) => {
      const div = document.createElement('div');
      div.textContent = text;
      div.style.padding = '10px';
      div.style.cursor = 'pointer';
      div.addEventListener('click', async () => {
        input.value = text;
        suggestionsContainer.innerHTML = '';
        const place_details =  await calToPlaceDetailsbyPlaceid(placeId);
        if(place_details){
          console.log("place_details",place_details);
          populateFields(place_details);
        }
      });
      suggestionsContainer.appendChild(div);
    });
  }
  
  input.addEventListener('focus', () => {
    suggestionsContainer.innerHTML = '';
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      suggestionsContainer.innerHTML = '';
    }
  });
  input.addEventListener('keydup', (event) => {
    if (event.key === 'Tab') {
      suggestionsContainer.innerHTML = '';
    }
  });
   async function calToPlaceDetailsbyPlaceid(place_id) {
    const payload = {
      place_id: place_id,
      show_address1_code: true,
      show_city_code: true
    };
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload),
    };
    try {
      //const response = await fetch(`https://shopifymultishipapp-ec3e3bef6fd5.herokuapp.com/get-postal-address-by-place-id`, requestOptions);
      const response = await fetch(`${SHOPIFY_APP_BASE_URL}/get-postal-address-by-place-id`, requestOptions);
      const result = await response.json();
      if (result?.status?.toLowerCase() === "ok") {
        
        return result.data.address || [];
      } else {
        console.warn("Failed to fetch address suggestions:", result.message || "Unknown error");
        return '';
      }
    } catch (error) {
      console.error("Error fetching address suggestions:", error);
      return {};
    }
  }
  async function populateFields(selectedAddress) {
    if (selectedAddress && typeof selectedAddress === 'object') {
      if (countryField) countryField.value = selectedAddress.country || '';
      if (address1Field) address1Field.value = selectedAddress.address1 || '';
      if (cityField) cityField.value = selectedAddress.city || '';
      if (stateField) stateField.value = selectedAddress.province || '';
      if (pinField) pinField.value = selectedAddress.zip || '';
      setTimeout(() => {
         loadAllStateCountryWise(selectedAddress.province);  // Custom function for handling states
      }, 300);
      mandatoryFieldChecking();
      return true;
    }
  }

  function mandatoryFieldChecking() {
    const fields = [
      'AddressFirstNameNew',
      'AddressLastNameNew',
      'AddressAddress1New',
      'AddressCityNew',
      'AddressCountryNew',
      'AddressZipNew'
    ];
    const allFilled = fields.every(id => document.getElementById(id)?.value.trim() !== '');
    const target = document.querySelector('#addAddressForShipping');
    if (!target) return;
    if (allFilled) {
      target.classList.remove('read-only');
    } else {
      target.classList.add('read-only');
    }
  }
  function  loadAllStateCountryWise(state){
    const elementId = "AddressProvinceNew";
    const countrySelect = document.getElementById("AddressCountryNew");
    const provinceSelect = document.getElementById("AddressProvinceNew");
    const provinceContainer = document.getElementById("AddressProvinceContainerNew");
    provinceSelect.innerHTML = "";
    const selectedOptioncuntry = countrySelect.options[countrySelect.selectedIndex];
    const provincesData = selectedOptioncuntry.getAttribute("data-provinces");
    if (provincesData) {
      const provinces = JSON.parse(provincesData);
      provinces.forEach(([provinceName, displayName]) => {
        const option = document.createElement("option");
        option.value = provinceName;
        option.textContent = displayName;
        provinceSelect.appendChild(option);
      });
      provinceContainer.style.display = "block";
      selectElement(elementId, state);
    } else {
      provinceContainer.style.display = "none";
      document.getElementById("AddressProvinceContainerNew").value="";
    }
  }
  function selectElement(id, valueToSelect) {
    if (valueToSelect.length <= 2) {
      valueToSelect = stateShortCodeToActualName(valueToSelect);
    }
    let element = document.getElementById(id);
    element.value = valueToSelect;
  }
  function countryShortCodeToActualName(countryCode) {
    let countryName = "";
    switch (countryCode) {
        case "UK":
            countryName = "United Kingdom";
            break;
        case "US":
        case "USA": // Combine cases with the same result
            countryName = "United States";
            break;
        case "AE":
        case "UAE":
            countryName = "United Arab Emirates";
            break;
        default:
            countryName = countryCode; // Default to the countryCode if no match
    }
    return countryName;
  }
  function stateShortCodeToActualName(stateCode) {
    const stateMap = {
        AL: "Alabama",
        AK: "Alaska",
        AZ: "Arizona",
        AR: "Arkansas",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DE: "Delaware",
        FL: "Florida",
        GA: "Georgia",
        HI: "Hawaii",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        IA: "Iowa",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        ME: "Maine",
        MD: "Maryland",
        MA: "Massachusetts",
        MI: "Michigan",
        MN: "Minnesota",
        MS: "Mississippi",
        MO: "Missouri",
        MT: "Montana",
        NE: "Nebraska",
        NV: "Nevada",
        NH: "New Hampshire",
        NJ: "New Jersey",
        NM: "New Mexico",
        NY: "New York",
        NC: "North Carolina",
        ND: "North Dakota",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PA: "Pennsylvania",
        RI: "Rhode Island",
        SC: "South Carolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TX: "Texas",
        UT: "Utah",
        VT: "Vermont",
        VA: "Virginia",
        WA: "Washington",
        WV: "West Virginia",
        WI: "Wisconsin",
        WY: "Wyoming"
    };
    const upperCaseCode = stateCode.toUpperCase();
    return stateMap[upperCaseCode] || "Invalid state code";
  }
  async function get_postal_code_suggestions_gapi(addressLine,functioncall=""){
    const request = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({ addressLine }),
    };

    try {
        const response = await fetch(`${SHOPIFY_APP_BASE_URL}/get-postal-code-suggestions-gapi`,request);
        const result = await response.json();

        if (result?.status?.toLowerCase() === "ok") {
            if(functioncall==""){
              pinField.value=result.data
            }
            address2Field.focus();
            return result.data;
        } else {
            console.warn("Failed to fetch address suggestions:", result.message || "Unknown error");
            return '';
        }
    } catch (error) {
        console.error("Error fetching address suggestions:", error);
        return '';
    }
  }
  function countryNameToCountryCode(countryName) {
    const countryNameToCodeMap = {
      "United States": "US",
      "India": "IN",
      "United Kingdom": "GB",
      "Canada": "CA",
      "France": "FR",
      "Germany": "DE",
    };
    const code = countryNameToCodeMap[countryName];
    return code || "Unknown Country Code";
  }
  document.querySelectorAll('.my-class').forEach(element => {
    element.addEventListener('change', function(event) {
        const validdata = addresslinevalidation();
    });
  });

  async function addresslinevalidation() {
    const address1Field = document.getElementById('AddressAddress1New').value.trim();
    const cityName = document.getElementById('AddressCityNew').value.trim();
    const countryName = document.getElementById('AddressCountryNew').value.trim();
    const pinField = document.getElementById('AddressZipNew').value.trim();
    const stateName = document.getElementById('AddressProvinceNew').value.trim();
    const addressLine = `${address1Field}, ${cityName}, ${stateName}, ${countryName}`;
    let zip = "";
    try {
      zip = await get_postal_code_suggestions_gapi(addressLine);

      if (zip && !Array.isArray(zip)) {
          document.getElementById('AddressZipNew').value = zip;
          removeClassesFromElements(
            '#addAddressForShipping',
            ['read-only']
          );
      } else {
          document.getElementById('AddressZipNew').value ="";
      }
    } catch (error) {
        document.getElementById('AddressZipNew').value ="";
        console.error("Error fetching postal code suggestions:", error);
    }
  }